<template>
  <v-container fluid grid-list-md>
    <v-layout wrap justify-center align-center>
    <v-layout wrap justify-left>
      <v-flex xs12 sm6>
        <span class="headline">Configurações da Empresa</span>
      </v-flex>
      <v-flex xs0 sm2>
      </v-flex>
      <v-flex xs12 sm4 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      </v-layout>
        <v-flex xs12>
          <v-card>
            <v-list two-line subheader>
              <v-layout>
                <v-flex xs10 lg11>
                  <v-subheader>Descrição</v-subheader>
                </v-flex>
                <v-flex xs2 lg1>
                  <v-subheader>Ações</v-subheader>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
                <v-list-tile v-for="item in filteredConfigs" :key="item.id">
                  <v-list-tile-action>
                    <v-checkbox
                      v-model="item.active"
                      @change="changeCheckbox(item)"
                    ></v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content @click="notifications = !notifications">
                    <v-list-tile-title style="color: black;font-weight: bold;font-family: Arial; word-break: break-word;">
                      {{item.text + item.statusText}}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-tooltip bottom>
                      <v-btn slot="activator" icon class="mx-0" @click="editItem(item)">
                        <v-icon color="teal">build</v-icon>
                      </v-btn>
                      <span>Editar</span>
                    </v-tooltip>
                  </v-list-tile-action>
                </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      <!--</v-layout>-->
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="900px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">Edição de configurações</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-md>
              <v-layout wrap align-center justify-center>
                <v-flex sm12 md5><h3 class="black--text">{{editedItem.text}}</h3></v-flex>
                <v-flex sm12 md7>
                  <p-select-multiple
                    :label="translate('table.tasks.field.task_status_id')" :rules="requiredManyRule(translate('table.tasks.field.task_status_id'))"
                    v-model="editedItem.status" :items="status" item_text="id_text" item_value="id"
                  ></p-select-multiple>
                </v-flex>
                <v-flex xs12>
                  <v-switch label="Ativo"
                    v-model="editedItem.active"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" @click.native="changeConfig(editedItem)">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  /* eslint-disable eqeqeq */
  import rules from './../../mixin/rules'
  import PSelectMultiple from './../shared/PSelectMultiple'

  export default {
    mixins: [rules],
    components: {PSelectMultiple},
    data: () => ({
      // items: {},
      status: [],
      allStatus: [],
      // params pega os valores do companyParams porem em json, deve ser inicializado com {}
      params: {},
      configs: [],
      dialog: false,
      search: '',
      // type: -1,
      // editText: '',
      editedItem: {id: '', text: '', statusText: '', status: [], active: false},
      defaultItem: {id: '', text: '', statusText: '', status: [], active: false}
    }),
    props: ['companyParams'],
    name: 'CompanyConfig',
    created () {
      this.$http.get(`api/task_status`).then((res) => {
        this.allStatus = res.body
        this.$store.commit('loader/change_dialog', false)
        // Monta os items de configuraçaõ
        this.mountConfig()
      }, (err) => {
        console.log(err)
        this.$store.commit('snackbar/change_values', {text: 'Não foi possível buscar os status, reporte o erro.', color: 'error', dialog: true})
      })
    },
    methods: {
      editItem (item) {
        // Quando for a configuração changeUser tira o status finalizado
        if (item.id === 'changeUser') {
          this.status = JSON.parse(JSON.stringify(this.allStatus.filter((val) => { return val.identifier != 3 })))
        } else {
          this.status = JSON.parse(JSON.stringify(this.allStatus))
        }

        Object.assign(this.editedItem, JSON.parse(JSON.stringify(item)))
        Object.assign(this.defaultItem, JSON.parse(JSON.stringify(item)))
        this.dialog = true
      },
      close (item) {
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.defaultItem)))
        this.dialog = false
      },
      changeCheckbox (item) {
        // Inclui os items no editedItem para pegar os valores antigos, como o status
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(item)))
        this.changeConfig(item)
      },
      changeConfig (item) {
        setTimeout(() => {
          if ((this.$refs.form && !this.$refs.form.validate())) {
            this.$store.commit('snackbar/change_values', {
              text: 'Por favor, corrija as validações antes de salvar!',
              color: 'warning',
              dialog: true
            })
            return false
          }
          // Modifica os status e o active do parametro em especifico para jogar tudo no banco
          // Precisa passar apenas os dois valores para não salvar tudo no banco
          this.params[item['id']]['status'] = item['status']
          this.params[item['id']]['active'] = item['active']
          this.$store.commit('loader/change_dialog', true)
          this.$http.put('api/companies/' + this.$auth.user().company_id, {params: JSON.stringify(this.params)}).then((res) => {
            // joga o valor de volta para os parametros na empresa
            this.$emit('input', JSON.stringify(this.params))
            this.$socket.emit('generalEvent', {
              data: this.params,
              responseEvent: 'changeCompanyParams',
              room: `user${this.$auth.user().id}`
            })
            // Muda os parametros para o usuário logado
            this.$auth.user().company.params = JSON.stringify(this.params)
            // Monta os items de configuração
            this.mountConfig(JSON.stringify(this.params))
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Registro editado com sucesso!',
              color: 'success',
              dialog: true
            })
          }, (err) => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível editar o registro, reporte o erro.',
              color: 'error',
              dialog: true
            })
          })
          this.dialog = false
        }, 200)
      },
      getStatusText (status = []) {
        let statusText = ''
        // Gera o texto com os status
        for (let i = 0; i < status.length; i++) {
          let statusItem = this.allStatus.find((val) => { return val.id == status[i] })
          statusText += (statusItem ? statusItem['id_text'] : '')
          // caso não esteja no último registro adiciona virgula
          if ((i + 1) < status.length) {
            statusText += ', '
          }
        }
        return statusText
      },
      mountConfig (params = this.companyParams) {
        // caso tenha parametros, pega e converte para json
        if (params) {
          let item = JSON.parse(params)
          Object.assign(this.params, item)
        }
        this.configs = [{id: 'startTime', text: 'Iniciar o tempo quando alterar o status para: ', statusText: this.getStatusText(this.params['startTime']['status']), status: this.params['startTime']['status'], active: this.params['startTime']['active']}, {id: 'stopTime', text: 'Parar o tempo quando alterar o status para: ', statusText: this.getStatusText(this.params['stopTime']['status']), status: this.params['stopTime']['status'], active: this.params['stopTime']['active']}]
        // Caso tenha o parametro de mudar o usuário aparece ele
        if (this.params.hasOwnProperty('changeUser')) {
          this.configs.push({id: 'changeUser', text: 'Altera o responsável da tarefa para o usuário logado, quando alterar o status para: ', statusText: this.getStatusText(this.params['changeUser']['status']), status: this.params['changeUser']['status'], active: this.params['changeUser']['active']})
        }
      }
    },
    computed: {
      filteredConfigs () {
        // filtra o que coloca no pesquisar
        return this.configs.filter(item => (item.text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') + item.statusText.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')).match(this.search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/CompanyConfig.vue